import { render } from "./DeleteReportForm.vue?vue&type=template&id=0c9e6210"
import script from "./DeleteReportForm.vue?vue&type=script&lang=js"
export * from "./DeleteReportForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__